module.exports = __webpack_public_path__ + "img/btn_prev.4e98666f.png";